import _ from 'lodash';
import { PointSetType } from '@/domain/pointSet/PointSetType';
import { SurfacelogType } from '@/domain/surfacelog/SurfacelogType';

const iconHelper = {
  getIcon(type) {
    if (!_.isString(type)) return null;
    if (type === PointSetType) return 'cx_as_built';
    if (type === SurfacelogType) return 'cx_points';
    // DrillHoleSetType functionality has been removed
    return null;
  },
};

export default iconHelper;